function DriverNames(drivers) {
    let name = "";
    drivers.forEach((Driver, index) => {

      var comma = " ";
      if(index != Object.keys(drivers).length - 1){
        var comma = ", ";
      }
      name = name+ Driver.driver.forename +' '+Driver.driver.surname+comma;
    });
    return name;
  }
  export default DriverNames;
